class a extends Error {
  constructor(e, n) {
    super(`Profile not found for source ${e} and destination ${n}`);
  }
}
class f extends Error {
  constructor() {
    super("Every value provided to loadProfiles must implement Profile");
  }
}
class p extends Error {
  constructor(e, n) {
    super(`Failed to Execute map for source "${e.sourceKey}" and destination "${e.destinationKey}"`, n);
  }
}
function u(r) {
  return Array.isArray(r) ? r : [r];
}
function l() {
  const r = /* @__PURE__ */ new Map();
  function e(t, o) {
    const s = `${t}-${o}`, i = r.get(s);
    if (!i)
      throw new a(t, o);
    return i;
  }
  return {
    register: (t) => {
      const o = u(t);
      for (const s of o)
        r.set(`${s.sourceKey}-${s.destinationKey}`, s);
    },
    has: (t, o) => {
      try {
        return e(t, o), !0;
      } catch {
        return !1;
      }
    },
    clear: () => {
      r.clear();
    },
    map: (t, o, s) => {
      const i = e(t, s);
      try {
        return i.map(o);
      } catch (c) {
        throw new p(i, { cause: c });
      }
    },
    mapMany: (t, o, s) => {
      const i = e(t, s);
      return o.map((c) => i.map(c));
    }
  };
}
function h(r, e, n) {
  return {
    sourceKey: r,
    destinationKey: e,
    map: n
  };
}
function y(r) {
  return typeof r == "function" ? r() : r;
}
function w(r) {
  const e = y(r), n = Object.values(e).flat(1 / 0);
  if (!n.every(d))
    throw new f();
  return n;
}
function d(r) {
  return !!r && typeof r == "object" && "sourceKey" in r && typeof r.sourceKey == "string" && "destinationKey" in r && typeof r.destinationKey == "string" && "map" in r && typeof r.map == "function";
}
const x = l();
export {
  a as ProfileNotFoundError,
  f as ProfileTypeError,
  l as createMapper,
  h as createProfile,
  x as default,
  w as loadProfiles
};
